/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_500_Meta_Pagetitle1Inputs */

const ja_error_500_meta_pagetitle1 = /** @type {(inputs: Error_500_Meta_Pagetitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`error500`)
};

const en_error_500_meta_pagetitle1 = /** @type {(inputs: Error_500_Meta_Pagetitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`error500`)
};

/**
* | output |
* | --- |
* | "error500" |
*
* @param {Error_500_Meta_Pagetitle1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const error_500_meta_pagetitle1 = /** @type {((inputs?: Error_500_Meta_Pagetitle1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_500_Meta_Pagetitle1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_error_500_meta_pagetitle1(inputs)
	return en_error_500_meta_pagetitle1(inputs)
});
export { error_500_meta_pagetitle1 as "error_500_meta_pageTitle" }